import { createFileRoute } from "@tanstack/react-router";
import { PlaybooksPage } from "@/features/settings/playbooks-page";

export const Route = createFileRoute("/_app/settings/playbooks")({ component: PlaybooksPage });
